var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBiTools = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.75 2.25C5.60786 2.25 2.25 5.60786 2.25 9.75C2.25 13.8921 5.60786 17.25 9.75 17.25C13.8921 17.25 17.25 13.8921 17.25 9.75C17.25 5.60786 13.8921 2.25 9.75 2.25ZM0.75 9.75C0.75 4.77944 4.77944 0.75 9.75 0.75C14.7206 0.75 18.75 4.77944 18.75 9.75C18.75 11.9653 17.9496 13.9936 16.6223 15.5616L23.0303 21.9697C23.3232 22.2626 23.3232 22.7375 23.0303 23.0304C22.7374 23.3232 22.2626 23.3232 21.9697 23.0304L15.5616 16.6223C13.9936 17.9496 11.9653 18.75 9.75 18.75C4.77944 18.75 0.75 14.7206 0.75 9.75ZM4.5 9.64286V12.657C4.88064 13.343 5.39183 13.9465 6 14.434V9.64286H4.5ZM7.5 4.5V15.3139C7.97302 15.5053 8.47602 15.6382 9 15.7036V4.5H7.5ZM10.5 9.64286V15.7036C11.024 15.6382 11.527 15.5053 12 15.3139V9.64286H10.5ZM13.5 7.92857V14.434C14.1082 13.9465 14.6194 13.343 15 12.657V7.92857H13.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBiTools);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bi-tools.962bb4cf58ff79199a9408c92cb92221.svg";